export default __webpack_public_path__ + "static/media/15.0653cc95.jpeg";